import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class IdleService {
  
  private timeout: any;
  private readonly IDLE_TIME = 15 * 60 * 1000; // 15 minutos

  constructor(private router: Router) {}

  init() {

    const resetTimer = () => {

      clearTimeout(this.timeout);

      this.timeout = setTimeout(() => {
        this.logout();
      }, this.IDLE_TIME);

    };

    const events = [
      'mousemove',
      'mousedown',
      'keypress',
      'touchstart',
      'scroll'
    ];

    events.forEach(event => {
      window.addEventListener(event, resetTimer);
    });

    resetTimer();
  }

  logout() {
    localStorage.removeItem('token');
    this.router.navigate(['/login']);
  }
}
